<template>
  <div class="resp-container" v-html="content" />
</template>

<script>
export default {

  name: 'BaseResponsiveEmbed',

  props: ['url'],

  computed: {
    content () {
      return this.ytEmbed(this.url)
    }
  }
}
</script>

<style lang="stylus" scoped>
.resp-container
  position relative
  overflow hidden
  padding-top 56.25%
  
  >>> iframe
    position absolute
    top 0
    left 0
    width 100%
    height 100%
    border 0
</style>